// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.dataconfiguration.diagnosis.UpdatePracticeDiagnosisRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdatePracticeDiagnosisRequest extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	carePlanTemplateId!: number | null;

	@GandalfValidator({ notNull: { message: 'Practice Diagnosis is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	practiceDiagnosisId!: number;

}
